import { Box } from "@mui/material";
import RedirectBackButton from "components/RedirectBackButton";
import SnackbarMessage from "components/SnackbarMessage";
import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useQueryClient } from "react-query";
import {
  IWizard,
  IWizardSaveRequest,
  SaveResponse,
  WizardSaveRequest,
} from "services/KnowfullyAdminClient";
import { SnackbarMessageProps } from "types/common-types";
import translateError from "utils/translateError";
import WizardForm from "./WizardForm";
import { ContextOrganizationFieldMode } from "components/ContextOrganizationField";

type WizardUpdateFormProps = {
  wizard: IWizard;
  onWizardUpdated: () => void;
  onCancel: () => void;
};

const WizardUpdateForm = ({
  wizard,
  onWizardUpdated,
  onCancel,
}: WizardUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { wizardsUrl, wizardService } = useGlobalContext();
  const queryClient = useQueryClient();
  const [
    snackbarMessage,
    setSnackbarMessage,
  ] = useState<SnackbarMessageProps | null>(null);

  const onSubmit = async (values: IWizardSaveRequest) => {
    try {
      const response: SaveResponse = await registerPromise(
        wizardService.saveWizard(
          new WizardSaveRequest({ ...values, id: wizard.id })
        )
      );

      queryClient.invalidateQueries("wizards");
      queryClient.invalidateQueries(["wizard", wizard.id]);

      onWizardUpdated();
      return response;
    } catch (err) {
      console.log(err);
      return { [FORM_ERROR]: translateError(err, t) };
    }
  };

  return (
    <>
      <Box my={2}>
        <RedirectBackButton
          redirectRoute={wizardsUrl()}
          labelKey="backToListButtonLabel"
        />
      </Box>
      <WizardForm
        wizard={wizard}
        onSubmit={onSubmit}
        submitLabel={t({ id: "wizardFormUpdateButton" })}
        organizationPickerMode={ContextOrganizationFieldMode.EditDisabled}
        onCancel={onCancel}
      />
      <SnackbarMessage
        snackbarMessage={snackbarMessage}
        setSnackbarMessage={setSnackbarMessage}
      />
    </>
  );
};

export default WizardUpdateForm;
